export const SET_SURVEY_CHOICE = "SET_SURVEY_CHOICE";
